/* eg-lymph-timeline — lights the timeline weeks with scroll.

   Desktop (card pinned): progress through the pinned run-way decides how many
   weeks are lit — week 1 from the start, one more every quarter — so scrolling
   back dims them in reverse.
   Tablet / mobile (no pin): each week lights once its top has scrolled above
   65% of the viewport, and dims again when it drops back below. */
(function () {
  'use strict';

  var TRIGGER = 0.65;

  function init(root) {
    if (!root || root.dataset.lftlInit === 'true') return;
    root.dataset.lftlInit = 'true';

    var pin = root.querySelector('[data-lftl-pin]');
    var card = pin && pin.firstElementChild;
    var steps = root.querySelectorAll('[data-lftl-step]');
    if (!pin || !card || !steps.length) return;

    var ticking = false;

    function light(count) {
      for (var i = 0; i < steps.length; i++) {
        steps[i].classList.toggle('is-lit', i < count);
      }
    }

    function update() {
      ticking = false;
      var pinned = getComputedStyle(card).position === 'sticky';

      if (pinned) {
        var runway = pin.offsetHeight - card.offsetHeight;
        var top = parseFloat(getComputedStyle(card).top) || 0;
        var travelled = top - pin.getBoundingClientRect().top;
        var progress = runway > 0 ? Math.min(1, Math.max(0, travelled / runway)) : 1;
        light(1 + Math.min(steps.length - 1, Math.floor(progress * steps.length)));
        return;
      }

      var line = window.innerHeight * TRIGGER;
      var count = 0;
      for (var i = 0; i < steps.length; i++) {
        if (steps[i].getBoundingClientRect().top < line) count = i + 1;
      }
      light(Math.max(1, count));
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-lftl]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
